module.exports = "/images/vendor/flag-icon-css/flags/4x3/tw.svg?8a194685378977299ae31f5e940b2d58";